import {fetchApiZip} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import * as types from './types'
import {createBlob} from 'shared/utils/createBlob'
import resetError from "shared/errorHandler/actions/resetError"
import handleError from "shared/errorHandler/actions/handleError"

export default (documentIds) => dispatch => {
    dispatch({type: types.GET_ZIPPED_PRODUCTS_START})
    dispatch(resetError())
    return fetchApiZip('/api/fb/briefing/zip?productIds=' + documentIds)
        .then(response => response.text())
        .then(response => {
            dispatch({
                type: types.GET_ZIPPED_PRODUCTS_SUCCESS, response: response
            })
        }).catch(error => {
            dispatch({
                type: types.GET_ZIPPED_PRODUCTS_FAILURE
            })
            dispatch(handleError({message: error.message, title: 'Error loading zipped products.'}))
        })
}

export const handler_GET_ZIPPED_PRODUCTS_START = (reduxState) => {
    if (reduxState.blobUrl !== undefined)
        URL.revokeObjectURL(reduxState.blobUrl)

    return ({
        ...reduxState,
        loadingToolbarButtons: {...reduxState.loadingToolbarButtons, zipProductsBtn: true},
        blobUrl: undefined
    })
}

export const handler_GET_ZIPPED_PRODUCTS_SUCCESS = (reduxState, action) => {
    const blob = createBlob(action.response, 'application/zip', 'document.zip')
    return ({
        ...reduxState,
        loadingToolbarButtons: {...reduxState.loadingToolbarButtons, zipProductsBtn: false},
        blobUrl: URL.createObjectURL(blob)
    })
}

export const handler_GET_ZIPPED_PRODUCTS_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        loadingToolbarButtons: {...reduxState.loadingToolbarButtons, zipProductsBtn: false}
    })
}

actionMap[types.GET_ZIPPED_PRODUCTS_START] = handler_GET_ZIPPED_PRODUCTS_START
actionMap[types.GET_ZIPPED_PRODUCTS_SUCCESS] = handler_GET_ZIPPED_PRODUCTS_SUCCESS
actionMap[types.GET_ZIPPED_PRODUCTS_FAILURE] = handler_GET_ZIPPED_PRODUCTS_FAILURE


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/getZippedProducts.js